angular.module('bizmetryApp').controller('BizEventsTabController', function (
    $scope, $mdDialog, $mdToast, $timeout, $interval,
    BusinessEventsService, ConfigurationService, dialogService,
    ProfileService
) {

    // ========================================
    // INICIALIZACIÓN
    // ========================================

    $scope.loadingBizEvents = false;
    $scope.filteredBizEvents = [];

    $scope.bizEvent = {
        totalItems: 0,
        page: 0,
        totalPages: 0,
        pageSize: 10,
        pageSizeOptions: [5, 10, 15, 25, 50, 100],
        searchDebounce: ConfigurationService.getFromCache('frontend.search_debounce_time') || 1000,
        sortOptions: [
            { value: 'name_asc', label: 'Name (A-Z)', field: 'biz_event_name', dir: 'asc' },
            { value: 'name_desc', label: 'Name (Z-A)', field: 'biz_event_name', dir: 'desc' },
            { value: 'date_asc', label: 'Oldest First', field: 'created_ts', dir: 'asc' },
            { value: 'date_desc', label: 'Newest First', field: 'created_ts', dir: 'desc' }
           
        ],
        selectedSort: 'name_asc',
        search: '',
        liveMode: false,
        liveEnvIds: [],         // env ids seleccionados para el filtro live; vacío = todos
        grammar: ''             // biz_event_trigger_id; vacío = todos
    };

    // Grammar filter options — every grammar in reference data, implemented or not
    $scope.grammarOptions = [];
    BusinessEventsService.getGrammarTypes()
        .then(function (types) { $scope.grammarOptions = types; })
        .catch(function (error) { console.error('[BizEventsTab] Error loading grammars:', error); });

    // Lista de environments del profile disponibles para filtrar
    $scope.liveEnvOptions = [];

    // Popula liveEnvOptions desde profile.environments cuando el profile está disponible
    function _buildLiveEnvOptions() {
        var envs = ($scope.profile && $scope.profile.environments) || [];
        $scope.liveEnvOptions = envs.map(function (e) {
            return { id: e.id, name: e.name };
        });
    }

    $scope.$watch('profile.environments', function (envs) {
        if (envs && envs.length) { _buildLiveEnvOptions(); }
    }, true);

    // ========================================
    // BULK SELECTION
    // ========================================

    $scope.selectedBizEventIds = [];

    // ========================================
    // EXPAND / COLLAPSE STATE
    // ========================================

    $scope.expandedEvents = {};

    $scope.toggleExpand = function (eventId) {
        $scope.expandedEvents[eventId] = !$scope.expandedEvents[eventId];
    };

    $scope.isBizEventSelected = function (id) {
        return $scope.selectedBizEventIds.indexOf(id) > -1;
    };

    $scope.toggleBizEventSelection = function (id) {
        var idx = $scope.selectedBizEventIds.indexOf(id);
        if (idx > -1) {
            $scope.selectedBizEventIds.splice(idx, 1);
        } else {
            $scope.selectedBizEventIds.push(id);
        }
    };

    $scope.allBizEventsSelected = function () {
        return $scope.filteredBizEvents.length > 0 &&
            $scope.selectedBizEventIds.length === $scope.filteredBizEvents.length;
    };

    $scope.someBizEventsSelected = function () {
        return $scope.selectedBizEventIds.length > 0 &&
            $scope.selectedBizEventIds.length < $scope.filteredBizEvents.length;
    };

    $scope.toggleSelectAllBizEvents = function () {
        if ($scope.allBizEventsSelected()) {
            $scope.selectedBizEventIds = [];
        } else {
            $scope.selectedBizEventIds = $scope.filteredBizEvents.map(function (e) {
                return e.biz_event_id;
            });
        }
    };

    $scope.clearBizEventSelection = function () {
        $scope.selectedBizEventIds = [];
    };

    // ========================================
    // BULK DELETE
    // ========================================

    $scope.bulkDeleteBizEvents = function () {
        if (!$scope.selectedBizEventIds || $scope.selectedBizEventIds.length === 0) { return; }

        var count = $scope.selectedBizEventIds.length;

        var label = count + ' business event' + (count !== 1 ? 's' : '');

        dialogService.showConfirmationDialog(
            'Delete ' + label,
            'You are about to permanently delete <strong>' + label + '</strong>. This action cannot be undone.',
            label,
            true
        ).then(function (decision) {
            if (decision !== 'confirmed') { return; }

            var idsToDelete = $scope.selectedBizEventIds.slice();
            $scope.selectedBizEventIds = [];
            $scope.loadingBizEvents = true;

            BusinessEventsService.bulkDelete(idsToDelete)
                .then(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(label + ' deleted successfully')
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.loadBizEvents();
                })
                .catch(function (err) {
                    console.error('[BizEventsTab] Bulk delete error:', err);
                    dialogService.showErrorDialog(
                        'Bulk Delete Failed',
                        dialogService.formatErrorMessage({
                            error: (err.data && err.data.error) || 'Delete Error',
                            message: (err.data && err.data.message) || 'An error occurred during bulk deletion.',
                            path: (err.data && err.data.path) || '/v1/api/bizmetry-biz-events/biz-event/byIds',
                            timestamp: (err.data && err.data.timestamp) || new Date().toISOString()
                        })
                    );
                    $scope.loadingBizEvents = false;
                });
        });
    };

    // ========================================
    // PURGE RETIRED/DEPRECATED — "Retire All" bulk action
    // Removes all RETIRED and DEPRECATED versions from the selected events.
    // ========================================
    $scope.purgeRetiredDeprecated = function () {
        if (!$scope.selectedBizEventIds || $scope.selectedBizEventIds.length === 0) { return; }

        // Collect the full event objects for the selected IDs
        var selectedEvents = $scope.filteredBizEvents.filter(function (e) {
            return $scope.selectedBizEventIds.indexOf(e.biz_event_id) > -1;
        });

        // Count how many versions will be purged so we can show a meaningful dialog
        var versionCount = 0;
        selectedEvents.forEach(function (e) {
            (e.versions || []).forEach(function (v) {
                if (v.biz_event_status === 'RETIRED' || v.biz_event_status === 'DEPRECATED') {
                    versionCount++;
                }
            });
        });

        if (versionCount === 0) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('No retired or deprecated versions found in the selected events.')
                    .position('top right')
                    .hideDelay(3500)
            );
            return;
        }

        var eventLabel = selectedEvents.length + ' event' + (selectedEvents.length !== 1 ? 's' : '');
        var versionLabel = versionCount + ' version' + (versionCount !== 1 ? 's' : '');

        dialogService.showConfirmationDialog(
            'Purge retired & deprecated versions',
            'You are about to permanently delete <strong>' + versionLabel + '</strong> ' +
            '(RETIRED &amp; DEPRECATED) across <strong>' + eventLabel + '</strong>. ' +
            'This action cannot be undone.',
            'Purge ' + versionLabel,
            true
        ).then(function (decision) {
            if (decision !== 'confirmed') { return; }

            $scope.loadingBizEvents = true;

            BusinessEventsService.purgeRetiredDeprecated($scope.selectedBizEventIds.slice())
                .then(function (resp) {
                    var result = resp.data || {};
                    $scope.selectedBizEventIds = [];
                    var purged = result.purged_count || 0;
                    var msg = purged + ' version' + (purged !== 1 ? 's' : '') + ' purged successfully';
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msg)
                            .position('top right')
                            .hideDelay(3500)
                    );
                    $scope.loadBizEvents();
                })
                .catch(function (err) {
                    console.error('[BizEventsTab] Purge error:', err);
                    $scope.loadingBizEvents = false;
                });
        });
    };

    // ========================================
    // BÚSQUEDA CON DEBOUNCE
    // ========================================

    var searchTimeout;

    $scope.debouncedBizEventSearch = function () {
        if (searchTimeout) { $timeout.cancel(searchTimeout); }
        searchTimeout = $timeout(function () {
            $scope.onBizEventNavBarChange();
        }, $scope.bizEvent.searchDebounce);
    };

    // ========================================
    // PAGINACIÓN
    // ========================================

    $scope.onBizEventPageDown = function () {
        if ($scope.bizEvent.page > 0) {
            $scope.bizEvent.page--;
            $scope.loadBizEvents();
        }
    };

    $scope.onBizEventPageUp = function () {
        if ($scope.bizEvent.page < $scope.bizEvent.totalPages - 1) {
            $scope.bizEvent.page++;
            $scope.loadBizEvents();
        }
    };

    $scope.onBizEventPageSizeChange = function () {
        $scope.bizEvent.page = 0;
        $scope.loadBizEvents();
    };

    // ========================================
    // HELPERS DE SORT
    // ========================================

    function resolveSort() {
        var opt = $scope.bizEvent.sortOptions.find(function (o) {
            return o.value === $scope.bizEvent.selectedSort;
        });
        return opt ? { field: opt.field, dir: opt.dir } : { field: 'biz_event_name', dir: 'asc' };
    }

    // ========================================
    // CARGAR BUSINESS EVENTS
    // ========================================

    /**
     * Normalizes a biz event header object coming from the API into the internal
     * model used by the frontend.
     *
     * The API returns live status as flat fields on the header:
     *   { is_live: true, live_envs: [{ id, name }, ...], bizEventLive: true (legacy) }
     *
     * The frontend expects a nested live_info object:
     *   { live_info: { is_live: true, envs: [{ id, name }, ...] } }
     *
     * This function builds live_info from is_live + live_envs and removes the
     * redundant bizEventLive field (deprecated — use is_live only).
     */
    function _normalizeBizEvent(event) {
        if (!event) { return event; }
        // Build live_info from the flat API fields
        event.live_info = {
            is_live: !!event.is_live,
            envs: Array.isArray(event.live_envs) ? event.live_envs : []
        };
        // Remove redundant / legacy fields from the header
        delete event.bizEventLive;
        // Grammar is fixed per event — shown once on the header row
        event.grammar = BusinessEventsService.getBizEventGrammar(event);
        // Sort versions ascending by semantic version (1.0, 2.0, 9.1, 10.0 — not lexicographic)
        if (Array.isArray(event.versions)) {
            event.versions.sort(function (a, b) {
                return compareVersionStrings(a.biz_event_version, b.biz_event_version);
            });
        }
        return event;
    }

    // `silent`: used by the auto-refresh poll below — skips the spinner and
    // doesn't blank the list or the current bulk-selection while the request
    // is in flight, so the row data (is_live/live_info) just swaps in place
    // every few seconds instead of flickering.
    $scope.loadBizEvents = function (silent) {
        if (!$scope.profile || !$scope.profile.id) { return; }

        if (!silent) {
            $scope.loadingBizEvents = true;
            $scope.filteredBizEvents = [];
            $scope.selectedBizEventIds = [];
            _loadDependencyStatuses();   // not on the silent poll — deps change rarely
        }

        var sort = resolveSort();

        BusinessEventsService.listByProfile($scope.profile.id, {
            page: $scope.bizEvent.page,
            size: $scope.bizEvent.pageSize,
            search: $scope.bizEvent.search,
            sortField: sort.field,
            sortDir: sort.dir,
            liveMode: $scope.bizEvent.liveMode,
            liveEnvIds: ($scope.bizEvent.liveMode && $scope.bizEvent.liveEnvIds.length)
                        ? $scope.bizEvent.liveEnvIds.join(',') : null,
            grammar: $scope.bizEvent.grammar || null
        })
            .then(function (response) {
                var data = response && response.data;
                _clearSourceGroupsCache();
                $scope.filteredBizEvents = ((data && data.content) || []).map(_normalizeBizEvent);
                $scope.bizEvent.totalPages = (data && data.totalPages) || 0;
                $scope.bizEvent.totalItems = (data && data.totalElements) || 0;
                $scope.bizEvent.page = (data && data.page) || 0;

                if ($scope.bizEvent.page >= $scope.bizEvent.totalPages && $scope.bizEvent.totalPages > 0) {
                    $scope.bizEvent.page = $scope.bizEvent.totalPages - 1;
                }
            })
            .catch(function (error) {
                if (error && error.status === 204) {
                    if (!silent) { $scope.filteredBizEvents = []; }
                    return;
                }
                console.error('[BizEventsTab] Error loading biz events:', error);
                if (!silent) { $scope.filteredBizEvents = []; }
            })
            .finally(function () {
                $scope.loadingBizEvents = false;
            });
    };

    // ========================================
    // CAMBIO DE FILTROS
    // ========================================

    $scope.onBizEventNavBarChange = function () {
        $scope.bizEvent.page = 0;
        _visibleVersionsCache = {};   // liveMode toggle changes which versions are visible
        $scope.loadBizEvents();
    };

    // ========================================
    // CREAR BUSINESS EVENT — lanza el wizard
    // ========================================

    $scope.createNewBizEvent = function () {
        _showPausingRefresh({
            controller: 'CreateBizEventWizardController',
            controllerAs: 'ctrl',
            templateUrl: 'profile/tabs/biz-events/create-wizard/create-biz-event-wizard.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: true,
            locals: { profile: $scope.profile }
        }).then(function (result) {
            if (result && result.created) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Business event created successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadBizEvents();
            }
        }).catch(angular.noop);
    };

    // ========================================
    // TOGGLE ENABLE/DISABLE
    // ========================================

    /**
     * Re-fetches one biz event and swaps its row data in place. The server is the
     * single source of truth: status, env_infos (is_live / capture_state), live_info
     * and enabled all change together after a toggle, transition or reinstate.
     * Resolves to the fresh event, or undefined when it's no longer listed.
     */
    function _refreshBizEventRow(bizEventId) {
        return BusinessEventsService.getById(bizEventId).then(function (res) {
            var fresh = _normalizeBizEvent(res.data);
            if (!fresh) { return; }

            var idx = $scope.filteredBizEvents.findIndex(function (e) {
                return e.biz_event_id === bizEventId;
            });
            if (idx === -1) { return; }

            // Sources may have changed with the fresh data.
            _clearSourceGroupsCache();

            var row = $scope.filteredBizEvents[idx];
            (fresh.versions || []).forEach(function (freshVer) {
                var localVIdx = row.versions.findIndex(function (lv) {
                    return lv.biz_event_version_id === freshVer.biz_event_version_id;
                });
                if (localVIdx !== -1) {
                    row.versions[localVIdx] = angular.copy(freshVer);
                }
            });
            row.live_info = angular.copy(fresh.live_info);
            row.is_live   = fresh.is_live;
            row.live_envs = angular.copy(fresh.live_envs);
            row.enabled   = fresh.enabled;
            return fresh;
        });
    }

    $scope.onToggleBizEventEnabled = function (event) {
        var previousState = event.enabled;

        BusinessEventsService.patch(event.biz_event_id, { enabled: event.enabled })
            .then(function () {
                // Every version's capture_state depends on enabled (DISABLED).
                _refreshBizEventRow(event.biz_event_id);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Business event ' + (event.enabled ? 'enabled' : 'disabled'))
                        .position('top right')
                        .hideDelay(2000)
                );
            })
            .catch(function (error) {
                console.error('[BizEventsTab] Error toggling event:', error);
                event.enabled = previousState;
                dialogService.showErrorDialog(
                    'Error',
                    'Failed to update event status. ' + ((error.data && error.data.message) || 'Unknown error')
                );
            });
    };

    // ========================================
    // STATUS TRANSITION
    // ========================================

    var TRANSITION_MAP = {
        'DRAFT': [{ label: 'Submit', icon: 'send', target: 'PENDING_REVIEW', css: 'submit' }],
        'PENDING_REVIEW': [{ label: 'Approve', icon: 'check_circle', target: 'APPROVED', css: 'approve' },
        { label: 'Reject', icon: 'cancel', target: 'REJECTED', css: 'reject' }],
        'APPROVED': [{ label: 'Publish', icon: 'publish', target: 'PUBLISHED', css: 'publish' }],
        'PUBLISHED': [{ label: 'Retire', icon: 'archive', target: 'RETIRED', css: 'retire' }],
        'REJECTED': [{ label: 'Reopen as Draft', icon: 'undo', target: 'DRAFT', css: 'reopen' }],
        'DEPRECATED': [{ label: 'Retire', icon: 'archive', target: 'RETIRED', css: 'retire' }],
        'RETIRED': []
    };

    // DEPRECATED / RETIRED versions are inactive in every environment (env dot shown red)
    $scope.isVersionInactive = function (version) {
        return !!version && (version.biz_event_status === 'DEPRECATED' || version.biz_event_status === 'RETIRED');
    };

    $scope.getTransitions = function (status) {
        return TRANSITION_MAP[status] || [];
    };

    // ── Publish preconditions ────────────────────────────────────────────
    // A version can only be PUBLISHED once its target template version is
    // PUBLISHED (biz-events enforces it with 409; this only greys the icon out
    // up front). Its API collections come from the template, which can only be
    // PUBLISHED once they all are. Statuses come from the light template-tree.
    var _depStatus = { templates: null };
    var _blockersCache = {};   // versionId → stable array (avoids $rootScope:infdig)
    var _NO_BLOCKERS = [];

    function _loadDependencyStatuses() {
        if (!$scope.profile || !$scope.profile.id) { return; }
        ProfileService.getTemplateTree($scope.profile.id, 'ASC').then(function (res) {
            var root = res && res.data;
            if (root && root['template-tree']) { root = root['template-tree']; }
            if (root && root.templateTree) { root = root.templateTree; }
            var map = {};
            (function walk(node) {
                if (!node || !node.id) { return; }
                map[node.id] = {
                    status:  node.status || node.templateStatus,
                    version: node.version || node.templateVersion
                };
                (node.children || []).forEach(walk);
            })(root);
            _depStatus.templates = map;
            _blockersCache = {};
        }).catch(function (err) {
            console.warn('[BizEventsTab] Could not load template statuses:', err);
        });
    }

    /** Reasons the version can't be published yet; empty when publishable or still unknown. */
    $scope.getPublishBlockers = function (version) {
        if (!_depStatus.templates) { return _NO_BLOCKERS; }
        var id = version.biz_event_version_id;
        if (_blockersCache[id]) { return _blockersCache[id]; }

        var blockers = [];
        var tplId = (version.biz_event_target && version.biz_event_target.template_instance_id)
            || version.target_template_instance_id;
        var tpl = tplId && _depStatus.templates[tplId];
        if (tpl && tpl.status !== 'PUBLISHED') {
            blockers.push('Template version v' + tpl.version + ' is ' + tpl.status);
        }
        _blockersCache[id] = blockers;
        return blockers;
    };

    /**
     * Tooltip lines for a version automatically recomputed after its template
     * or an API collection changed (recompute_summary). Memoized per version +
     * recompute timestamp so the digest sees a stable array (avoids infdig).
     */
    var _recomputeCache = {};
    var _NO_RECOMPUTE = [];
    $scope.getRecomputeLines = function (version) {
        var s = version && version.recompute_summary;
        if (!s) { return _NO_RECOMPUTE; }
        var key = version.biz_event_version_id + '|' + s.recomputed_ts;
        if (_recomputeCache[key]) { return _recomputeCache[key]; }

        var lines = [];
        (s.reasons || []).forEach(function (r) { lines.push(r); });
        function add(title, items) {
            if (items && items.length) {
                lines.push(title + ':');
                items.forEach(function (i) { lines.push('  • ' + i); });
            }
        }
        add('Dropped', s.dropped);
        add('Remapped by IntelliSense', s.remapped);
        add('Broken sources', s.broken_sources);
        add('Updated', s.updated);
        add('Review', s.review);
        add('New unmapped', s.unmapped);
        if (s.status_reverted_from) { lines.push('Status reverted ' + s.status_reverted_from + ' → DRAFT'); }
        lines.push('Click to dismiss.');
        _recomputeCache[key] = lines;
        return lines;
    };

    /** Badge click: acknowledge the recompute. Hidden at once; restored if the call fails. */
    $scope.dismissRecompute = function (version, $event) {
        if ($event) { $event.stopPropagation(); }
        var summary = version && version.recompute_summary;
        if (!summary) { return; }
        // The backend keeps only the IntelliSense in-progress mark — mirror it so that badge stays.
        version.recompute_summary = summary.intellisense_pending_since
            ? { intellisense_pending_since: summary.intellisense_pending_since } : null;
        BusinessEventsService.dismissRecomputeSummary(version.biz_event_version_id)
            .catch(function (err) {
                console.warn('[BizEventsTab] Could not dismiss recompute summary:', err);
                version.recompute_summary = summary;
            });
    };

    /** IntelliSense is mapping what a template / API change left unmapped (~1 min). */
    $scope.isIntelliSensePending = function (version) {
        return !!BusinessEventsService.intelliSensePendingSince(version);
    };

    /** "12s ago" / "1 min ago" since IntelliSense started on the version. */
    $scope.intelliSensePendingAgo = function (version) {
        var since = BusinessEventsService.intelliSensePendingSince(version);
        if (!since) { return ''; }
        var secs = Math.max(0, Math.round((Date.now() - since) / 1000));
        return secs < 60 ? secs + 's ago' : Math.floor(secs / 60) + ' min ago';
    };

    /** The "Recomputed" badge has something to tell (not only the in-progress mark). */
    $scope.hasRecomputeNotice = function (version) {
        var s = version && version.recompute_summary;
        if (!s) { return false; }
        return ['reasons', 'dropped', 'remapped', 'broken_sources', 'updated', 'review', 'unmapped']
            .some(function (k) { return s[k] && s[k].length; }) || !!s.status_reverted_from;
    };

    /** True when the recompute removed something (drives the warning color). */
    $scope.isRecomputeSevere = function (version) {
        var s = version && version.recompute_summary;
        return !!(s && ((s.dropped && s.dropped.length) || (s.broken_sources && s.broken_sources.length)));
    };

    $scope.isTransitionBlocked = function (event, version, tr) {
        return (tr.target === 'RETIRED' && $scope.isDefaultVersion(event, version))
            || (tr.target === 'PUBLISHED' && $scope.getPublishBlockers(version).length > 0);
    };

    /**
     * Returns true when a PUBLISHED or DEPRECATED version is the sole
     * "active" version of the event — meaning there is no other version
     * in a state that could eventually reach PUBLISHED (DRAFT, PENDING_REVIEW,
     * APPROVED, REJECTED).  In that case retiring it would leave the event
     * with no path to an active published version, so the Retire action
     * must be blocked.
     *
     * Versions in PUBLISHED, DEPRECATED or RETIRED are excluded from the
     * "active alternative" check because:
     *   - PUBLISHED / DEPRECATED can themselves be retired
     *   - RETIRED is terminal
     */
    var _RETIRABLE_GUARD_STATUSES = ['DRAFT', 'PENDING_REVIEW', 'APPROVED', 'REJECTED'];

    function compareVersionStrings(a, b) {
        var pa = String(a || '0').split('.').map(function (x) { var n = parseInt(x, 10); return isNaN(n) ? 0 : n; });
        var pb = String(b || '0').split('.').map(function (x) { var n = parseInt(x, 10); return isNaN(n) ? 0 : n; });
        var len = Math.max(pa.length, pb.length);
        for (var i = 0; i < len; i++) {
            var av = pa[i] !== undefined ? pa[i] : 0;
            var bv = pb[i] !== undefined ? pb[i] : 0;
            if (av !== bv) return av - bv;
        }
        return 0;
    }

    $scope.isDefaultVersion = function (event, version) {
        // Solo las versiones PUBLISHED pueden ser "default".
        if (version.biz_event_status !== 'PUBLISHED') {
            return false;
        }

        // Con el modelo multi-PUBLISHED (una PUBLISHED por templateInstanceId),
        // la "versión default" — la única que no puede retirarse — es la versión
        // PUBLISHED con el número de versión semántica más bajo.
        // Las demás versiones PUBLISHED son para otros templates y pueden retirarse.
        var versions = event.versions || [];
        var publishedVersions = versions.filter(function (v) {
            return v.biz_event_status === 'PUBLISHED';
        });

        if (publishedVersions.length === 0) return false;

        // Ordenar semánticamente y tomar la más baja
        publishedVersions.sort(function (a, b) {
            return compareVersionStrings(a.biz_event_version, b.biz_event_version);
        });

        var lowestPublished = publishedVersions[0];
        return lowestPublished.biz_event_version_id === version.biz_event_version_id;
    };

    // ========================================
    // RE-INSTATE VERSION
    // Restores a DEPRECATED version directly to PUBLISHED.
    // Only shown when version.can_reinstate === true (computed server-side).
    // ========================================

    // Tracks which version has its re-instate confirmation dialog open.
    // Prevents double-invocation when the click bubbles from the inner md-icon
    // to the md-button before versionTransitioning is set (the dialog is async).
    $scope.reinstateDialogOpen = {};

    $scope.reinstateVersion = function (event, version, $event) {
        if ($event) { $event.stopPropagation(); }

        // Guard against double-click / event bubbling before the dialog opens.
        if ($scope.versionTransitioning[version.biz_event_version_id] ||
                $scope.reinstateDialogOpen[version.biz_event_version_id]) {
            return;
        }
        $scope.reinstateDialogOpen[version.biz_event_version_id] = true;

        dialogService.showDecisionDialog(
            'Re-instate version ' + version.biz_event_version,
            'This will restore version <strong>' + version.biz_event_version +
            '</strong> to <strong>PUBLISHED</strong> status for the associated template. ' +
            'The event will become active again.'
        ).then(function (decision) {
            if (decision !== 'proceed') { return; }

            $scope.versionTransitioning[version.biz_event_version_id] = true;

            BusinessEventsService.reinstateVersion(
                event.biz_event_id,
                version.biz_event_version_id
            ).then(function () {
                // Always fetch the full event from the server — same pattern as
                // _doTransitionVersionStatus — so every field (status, env_infos,
                // is_live, can_reinstate) is guaranteed to be fresh and consistent.
                return _refreshBizEventRow(event.biz_event_id).then(function (fresh) {
                    if (!fresh) { return; }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('✅ Version ' + version.biz_event_version + ' re-instated to PUBLISHED.')
                            .position('top right')
                            .hideDelay(2500)
                    );
                });
            }).catch(function (err) {
                var errData = err.data || {};
                dialogService.showErrorDialog(
                    'Re-instate Failed',
                    dialogService.formatErrorMessage(errData)
                );
                console.error('[BizEventsTab] reinstateVersion error:', err);
            }).finally(function () {
                delete $scope.versionTransitioning[version.biz_event_version_id];
            });
        }).finally(function () {
            delete $scope.reinstateDialogOpen[version.biz_event_version_id];
        });
    }; // ========================================
    // STATUS TRANSITION — VERSION level
    // ========================================

    $scope.transitionVersionStatus = function (event, version, targetStatus, $event) {
        if ($event) { $event.stopPropagation(); }

        // PUBLISH — compute environment-level impact before proceeding.
        //
        // profile.environments already contains every env with its assigned
        // templateInstanceId. We use that to build a precise impact summary:
        //
        //   going_offline : envs currently live on the OLD template that will
        //                   lose coverage because they are NOT assigned the new one
        //   coming_online  : envs assigned to the NEW template that will gain coverage
        //   staying_live   : envs assigned to BOTH (edge case, same template)
        //
        // We always show the dialog when the event is live so the user understands
        // the consequences — even a net-positive transition (old env drops, new env
        // picks up) deserves an explicit confirmation.
        if (targetStatus === 'PUBLISHED') {
            var isLiveNow = event.enabled && event.live_info && event.live_info.is_live;
            var newTplId = version.biz_event_target && version.biz_event_target.template_instance_id;

            if (isLiveNow && newTplId && $scope.profile) {
                var profileEnvs = Array.isArray($scope.profile.environments)
                    ? $scope.profile.environments : [];

                // Current live env ids (from biz event live_info)
                var currentLiveEnvIds = {};
                (event.live_info.envs || []).forEach(function (e) {
                    currentLiveEnvIds[e.id] = e.name;
                });

                // Modelo multi-PUBLISHED: cada versión PUBLISHED del biz event se asocia
                // a un templateInstanceId distinto, y cada template solo puede asignarse
                // a un subconjunto de environments.
                //
                // Por lo tanto, el único impacto real es cuando un env actualmente vivo
                // pierde su cobertura porque el biz event deja de tener una versión
                // PUBLISHED para el template que ese env tiene asignado.
                //
                // Calculamos los templateInstanceIds que tendrán cobertura DESPUÉS del publish:
                //   1. El template de la versión que se publica ahora (newTplId)
                //   2. Los templates de las otras versiones PUBLISHED que NO se auto-deprecan
                //      (solo se depreca la que tiene el mismo templateInstanceId que newTplId)

                // Modelo multi-PUBLISHED: editar una versión PUBLISHED genera un fork
                // automático (nueva versión DRAFT), por lo que la versión original sigue
                // activa. El warning solo aplica cuando al publicar esta versión DRAFT,
                // algún env live queda SIN NINGUNA versión PUBLISHED que lo cubra.
                //
                // "Cubrir un env" = tener una versión PUBLISHED cuyo templateInstanceId
                // coincide con el templateInstanceId asignado a ese env.

                // Templates cubiertos después del publish:
                //   - El template de esta versión (newTplId) — siempre
                //   - Los templates de otras versiones PUBLISHED con distinto templateInstanceId
                //     (el del mismo templateInstanceId se auto-depreca, pero eso está bien
                //      porque esta versión lo reemplaza)
                var otherPublishedVersions = (event.versions || []).filter(function (v) {
                    return v.biz_event_status === 'PUBLISHED'
                        && v.biz_event_version_id !== version.biz_event_version_id;
                });

                var coveredAfterPublish = {};
                coveredAfterPublish[newTplId] = true;
                otherPublishedVersions.forEach(function (v) {
                    var tplId = v.biz_event_target && v.biz_event_target.template_instance_id;
                    if (tplId && tplId !== newTplId) {
                        coveredAfterPublish[tplId] = true;
                    }
                });

                // Envs live cuyo template NO queda cubierto → pierden cobertura real
                var goingOffline = profileEnvs.filter(function (env) {
                    return currentLiveEnvIds[env.id]
                        && env.templateInstanceId
                        && !coveredAfterPublish[env.templateInstanceId];
                }).map(function (env) { return env.name; });

                // Envs del nuevo template que ganan cobertura (no estaban live)
                var comingOnline = profileEnvs.filter(function (env) {
                    return env.templateInstanceId === newTplId
                        && !currentLiveEnvIds[env.id];
                }).map(function (env) { return env.name; });

                // Envs del nuevo template ya live (sin cambio)
                var stayingLive = profileEnvs.filter(function (env) {
                    return env.templateInstanceId === newTplId
                        && currentLiveEnvIds[env.id];
                }).map(function (env) { return env.name; });

                var willGoFullyOffline = goingOffline.length > 0
                    && comingOnline.length === 0
                    && stayingLive.length === 0;

                // Solo mostrar el warning si hay envs que realmente pierden cobertura
                var hasAnyImpact = goingOffline.length > 0;

                if (hasAnyImpact) {
                    // Build impact summary block
                    var impactHtml = '';

                    if (willGoFullyOffline) {
                        impactHtml +=
                            '<div style="margin-top:12px;padding:10px 12px;' +
                            'background:rgba(239,68,68,0.07);border-left:3px solid #ef4444;' +
                            'border-radius:4px;font-size:12px;color:#b91c1c;line-height:1.6;">' +
                            '<strong>⚠ This biz event will go fully offline after publishing.</strong><br>' +
                            'The new template is not assigned to any active environment.';
                    } else {
                        impactHtml +=
                            '<div style="margin-top:12px;padding:10px 12px;' +
                            'background:rgba(245,158,11,0.07);border-left:3px solid #f59e0b;' +
                            'border-radius:4px;font-size:12px;color:#78350f;line-height:1.6;">' +
                            '<strong>⚠ Environment coverage will change after publishing.</strong>';
                    }

                    if (goingOffline.length > 0) {
                        impactHtml += '<br>🔴 Will go offline: <strong>' +
                            goingOffline.join(', ') + '</strong>';
                    }
                    if (comingOnline.length > 0) {
                        impactHtml += '<br>🟢 Will come online: <strong>' +
                            comingOnline.join(', ') + '</strong>';
                    }
                    if (stayingLive.length > 0) {
                        impactHtml += '<br>🟡 Already live, unaffected: <strong>' +
                            stayingLive.join(', ') + '</strong>';
                    }

                    impactHtml += '</div>';

                    var publishMsg =
                        'You are about to publish version <strong>v' + version.biz_event_version +
                        '</strong> of <strong>' + event.biz_event_name + '</strong>.' +
                        impactHtml;

                    dialogService.showConfirmationDialog(
                        'Confirm Publish',
                        publishMsg,
                        'v' + version.biz_event_version,
                        true,
                        'Publish anyway'
                    ).then(function (decision) {
                        if (decision !== 'confirmed') { return; }
                        _doTransitionVersionStatus(event, version, targetStatus);
                    });
                    return;
                }
            }
            // No live impact — proceed directly.
            _doTransitionVersionStatus(event, version, targetStatus);
            return;
        }

        // RETIRE — DEPRECATED versions retire silently (already superseded, no risk).
        // PUBLISHED versions always ask for confirmation; add live warning only when
        // THIS specific version is currently live (has env_infos with is_live=true).
        if (targetStatus === 'RETIRED') {
            if (version.biz_event_status === 'DEPRECATED') {
                _doTransitionVersionStatus(event, version, targetStatus);
                return;
            }
            // Check live state at VERSION level, not header level.
            // A version is live only when it has env_infos entries with is_live=true
            // AND the header is enabled. v2.0 can be PUBLISHED but not assigned to any
            // live env — in that case no warning is needed.
            var versionLiveEnvs = event.enabled
                ? (version.env_infos || []).filter(function (e) { return e.is_live; })
                : [];
            var isVersionLive = versionLiveEnvs.length > 0;
            var liveEnvNames = versionLiveEnvs.map(function (e) { return e.name; }).join(' · ');

            var retireMsg = 'You are about to retire version <strong>v' + version.biz_event_version + '</strong> of <strong>' + event.biz_event_name + '</strong>. Retired versions cannot be re-activated.';
            if (isVersionLive) {
                retireMsg += '<div style="margin-top:12px;padding:10px 12px;background:rgba(239,68,68,0.07);border-left:3px solid #ef4444;border-radius:4px;font-size:12px;color:#b91c1c;line-height:1.5;">' +
                    '<strong>⚠ This version is currently live' + (liveEnvNames ? ' in: ' + liveEnvNames : '') + '.</strong><br>' +
                    'Retiring it will cause agents to stop capturing and forwarding business telemetry frames associated with it.' +
                    '</div>';
            }
            dialogService.showConfirmationDialog(
                'Retire Version',
                retireMsg,
                'v' + version.biz_event_version,
                true,
                'Proceed'
            ).then(function (decision) {
                if (decision !== 'confirmed') { return; }
                _doTransitionVersionStatus(event, version, targetStatus);
            });
            return;
        }

        _doTransitionVersionStatus(event, version, targetStatus);
    };

    // Tracks which version is mid-transition so the row can show a spinner.
    // Keyed by biz_event_version_id; value = true while PATCH + getById are in flight.
    $scope.versionTransitioning = {};

    function _doTransitionVersionStatus(event, version, targetStatus) {

        // Mark this version as transitioning — shows spinner, disables action buttons.
        $scope.versionTransitioning[version.biz_event_version_id] = true;

        BusinessEventsService.patchVersion(event.biz_event_id, version.biz_event_version, {
            biz_event_status: targetStatus
        })
            .then(function () {
                // No optimistic update — the server is the single source of truth.
                // We always fetch the full event so every field (biz_event_status,
                // env_infos.is_live, live_info, enabled, etc.) is consistent after
                // any transition: DRAFT→PUBLISHED, PUBLISHED→DEPRECATED side-effects,
                // PUBLISHED→RETIRED, DEPRECATED→RETIRED, etc.
                return _refreshBizEventRow(event.biz_event_id).then(function (fresh) {
                    if (!fresh) { return; }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Status updated to ' + targetStatus.replace(/_/g, ' '))
                            .position('top right')
                            .hideDelay(2500)
                    );
                });
            })
            .catch(function (err) {
                console.error('[BizEventsTab] transitionVersionStatus error:', err);
                dialogService.showErrorDialog(
                    'Status Transition Failed',
                    (err.data && err.data.message) || 'Could not transition version status.'
                );
            })
            .finally(function () {
                delete $scope.versionTransitioning[version.biz_event_version_id];
            });
    }

    // ========================================
    // INLINE EDIT — name + description in-row
    // ========================================

    // Maps keyed by biz_event_id
    $scope.inlineEdit = {};   // 'name' | 'desc' | null — active field
    $scope.inlineDraft = {};   // { name, desc } draft values per event
    $scope.inlineNameError = {};   // error message string | null per event

    // Cache of all lowercase names for the current profile (lazy-loaded)
    var _allNameCache = null;      // null = not loaded yet

    /** Load all names once per profile; refresh on demand. */
    function _loadNameCache() {
        if (!$scope.profile || !$scope.profile.id) { return; }
        BusinessEventsService.getAllNames($scope.profile.id).then(function (names) {
            _allNameCache = names;  // array of lowercase strings
        });
    }

    /** Invalidate cache whenever a new profile is selected. */
    $scope.$watch('profile.id', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) { _allNameCache = null; }
    });

    /**
     * Check whether a candidate name is already used by another event.
     * @param {string} candidate   — trimmed, raw-case value being typed
     * @param {string} ownId       — biz_event_id of the event being edited (excluded)
     * @param {string} ownOriginal — current saved name of that event (excluded)
     * @returns {boolean}
     */
    function _isDuplicateName(candidate, ownId, ownOriginal) {
        var lower = candidate.toLowerCase();
        // Always exclude the event's own current name
        var ownLower = (ownOriginal || '').trim().toLowerCase();
        if (lower === ownLower) { return false; }

        if (_allNameCache) {
            // Remove own saved name from the set for comparison
            return _allNameCache.some(function (n) {
                return n !== ownLower && n === lower;
            });
        }
        // Cache not ready yet — fall back to the loaded page only
        return $scope.filteredBizEvents.some(function (e) {
            return e.biz_event_id !== ownId &&
                (e.biz_event_name || '').trim().toLowerCase() === lower;
        });
    }

    $scope.startInlineEdit = function ($event, event, field) {
        $event.stopPropagation();
        var id = event.biz_event_id;
        $scope.inlineDraft[id] = $scope.inlineDraft[id] || {};
        $scope.inlineDraft[id].name = event.biz_event_name;
        $scope.inlineDraft[id].desc = event.biz_event_description || '';
        $scope.inlineNameError[id] = null;
        $scope.inlineEdit[id] = field;

        // Lazy-load name cache on first inline edit
        if (_allNameCache === null) { _loadNameCache(); }
    };

    /** Called on ng-change of the name input — real-time duplicate check. */
    $scope.onInlineNameChange = function (event) {
        var id = event.biz_event_id;
        var draft = $scope.inlineDraft[id];
        var candidate = (draft && draft.name || '').trim();

        if (!candidate) {
            $scope.inlineNameError[id] = 'Name is required';
            return;
        }
        if (_isDuplicateName(candidate, id, event.biz_event_name)) {
            $scope.inlineNameError[id] = 'An event with this name already exists';
        } else {
            $scope.inlineNameError[id] = null;
        }
    };

    /** Returns true when the name input is in an invalid state (blocks commit). */
    $scope.inlineNameInvalid = function (event) {
        var id = event.biz_event_id;
        var draft = $scope.inlineDraft[id];
        var candidate = (draft && draft.name || '').trim();
        if (!candidate) { return true; }
        return !!$scope.inlineNameError[id];
    };

    $scope.commitInlineEdit = function (event, field) {
        var id = event.biz_event_id;
        var draft = $scope.inlineDraft[id];

        if (!draft) { $scope.inlineEdit[id] = null; return; }

        var newName = (draft.name || '').trim();
        var newDesc = (draft.desc || '').trim();

        // Block commit when name is invalid (empty or duplicate)
        if (field === 'name' && $scope.inlineNameInvalid(event)) {
            return;   // keep input open so user must fix it
        }

        $scope.inlineEdit[id] = null;

        // Nothing changed — skip API call
        if (newName === event.biz_event_name && newDesc === (event.biz_event_description || '')) {
            return;
        }

        BusinessEventsService.patch(id, {
            biz_event_name: newName,
            biz_event_description: newDesc
        }).then(function () {
            event.biz_event_name = newName;
            event.biz_event_description = newDesc;
            // Update cache to reflect the rename
            if (_allNameCache) {
                var oldLower = event.biz_event_name.trim().toLowerCase();
                var idx = _allNameCache.indexOf(oldLower);
                if (idx !== -1) { _allNameCache[idx] = newName.toLowerCase(); }
                else { _allNameCache.push(newName.toLowerCase()); }
            }
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Event updated')
                    .position('top right')
                    .hideDelay(2000)
            );
        }).catch(function (err) {
            dialogService.showErrorDialog('Update Failed',
                (err.data && err.data.message) || 'Could not update event.');
        });
    };

    $scope.cancelInlineEdit = function (event) {
        var id = event.biz_event_id;
        $scope.inlineEdit[id] = null;
        $scope.inlineNameError[id] = null;
    };

    $scope.onInlineKeydown = function ($event, event, field) {
        if ($event.key === 'Enter') {
            $event.preventDefault();
            // Only blur (→ commit) when name is valid
            if (field === 'name' && $scope.inlineNameInvalid(event)) { return; }
            $event.target.blur();
        }
        if ($event.key === 'Escape') {
            $event.preventDefault();
            $scope.cancelInlineEdit(event);
        }
        if ($event.key === 'Tab' && !$event.shiftKey && field === 'name') {
            $event.preventDefault();
            if ($scope.inlineNameInvalid(event)) { return; }
            $scope.inlineEdit[event.biz_event_id] = 'desc';
        }
    };


    // ========================================
    // EDIT EVENT — name + description only
    // ========================================

    $scope.openEditBizEventDialog = function (event) {
        _showPausingRefresh({
            controller: function ($scope, $mdDialog, event) {
                $scope.form = { name: event.biz_event_name, description: event.biz_event_description || '' };
                $scope.save = function () { $mdDialog.hide($scope.form); };
                $scope.cancel = function () { $mdDialog.cancel(); };
            },
            locals: { event: event },
            template: [
                '<md-dialog style="min-width:440px; border-radius:8px;">',
                '  <md-toolbar class="md-primary" style="background:linear-gradient(135deg,#667eea,#764ba2);">',
                '    <div class="md-toolbar-tools"><h2 style="font-size:15px;font-weight:700;">Edit Business Event</h2>',
                '      <span flex></span>',
                '      <md-button class="md-icon-button" ng-click="cancel()"><md-icon style="color:white;">close</md-icon></md-button>',
                '    </div>',
                '  </md-toolbar>',
                '  <md-dialog-content style="padding:24px;">',
                '    <md-input-container class="md-block">',
                '      <label>Event Name</label>',
                '      <input ng-model="form.name" required />',
                '    </md-input-container>',
                '    <md-input-container class="md-block">',
                '      <label>Description</label>',
                '      <textarea ng-model="form.description" rows="3"></textarea>',
                '    </md-input-container>',
                '  </md-dialog-content>',
                '  <md-dialog-actions style="padding:12px 16px;justify-content:flex-end;gap:8px;display:flex;">',
                '    <md-button ng-click="cancel()">Cancel</md-button>',
                '    <md-button class="md-raised md-primary" ng-click="save()" ng-disabled="!form.name">Save</md-button>',
                '  </md-dialog-actions>',
                '</md-dialog>'
            ].join(''),
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            multiple: true
        }).then(function (form) {
            BusinessEventsService.patch(event.biz_event_id, {
                biz_event_name: form.name,
                biz_event_description: form.description
            }).then(function () {
                event.biz_event_name = form.name;
                event.biz_event_description = form.description;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Event updated successfully')
                        .position('top right')
                        .hideDelay(2500)
                );
            }).catch(function (err) {
                dialogService.showErrorDialog('Update Failed',
                    (err.data && err.data.message) || 'Could not update event.');
            });
        }).catch(angular.noop);
    };

    // ========================================
    // EDIT VERSION — opens wizard in edit mode
    // ========================================

    // While IntelliSense maps what a template / API change left unmapped, the version's mappings
    // are about to change: an editor would show (and could save over) a stale state.
    function _blockedByIntelliSense(version) {
        if (!BusinessEventsService.intelliSensePendingSince(version)) { return false; }
        $mdToast.show($mdToast.simple()
            .textContent('IntelliSense is updating this version\'s mappings — it can be edited when it finishes.')
            .position('top right').hideDelay(4000));
        return true;
    }

    $scope.openEditVersionDialog = function (event, version, $event) {
        if ($event) { $event.stopPropagation(); }
        if (_blockedByIntelliSense(version)) { return; }

        _showPausingRefresh({
            controller: 'EditBizEventVersionController',
            controllerAs: 'ctrl',
            templateUrl: 'profile/tabs/biz-events/edit-wizard/edit-biz-event-version-wizard.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: true,
            locals: {
                bizEvent: event,
                version: version,
                profile: $scope.profile
            }
        }).then(function (result) {
            if (result && result.reopen) {          // IntelliSense finished: load its mappings
                $scope.openEditVersionDialog(event, result.version || version);
                return;
            }
            if (result && result.updated) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Business event updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadBizEvents();
            }
        }).catch(angular.noop);
    };

    // ========================================
    // EDIT MAPPINGS — opens the quick mapping editor (no full wizard)
    // ========================================

    $scope.openEditMappingsDialog = function (event, version, $event) {
        if ($event) { $event.stopPropagation(); }
        if (_blockedByIntelliSense(version)) { return; }

        _showPausingRefresh({
            controller: 'EditBizEventMappingsController',
            controllerAs: 'ctrl',
            templateUrl: 'profile/tabs/biz-events/edit-mappings/edit-biz-event-mappings-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: true,
            locals: {
                bizEvent: event,
                version: version,
                profile: $scope.profile
            }
        }).then(function (result) {
            if (result && result.updated) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Mappings updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadBizEvents();
            }
        }).catch(angular.noop);
    };

    // ========================================
    // ELIMINAR — doble clic con ícono titilante + showConfirmationDialog
    // ========================================

    $scope.confirmDeleteBizEventMap = {};
    $scope.deleteBizEventTimers = {};
    var CONFIRM_TIMEOUT_MS = 3000;

    // Clones the event with all of its versions as "Copy of <name>" (created disabled).
    $scope.cloningBizEventMap = {};
    $scope.cloneBizEvent = function (event) {
        if ($scope.cloningBizEventMap[event.biz_event_id]) { return; }
        $scope.cloningBizEventMap[event.biz_event_id] = true;

        BusinessEventsService.clone(event.biz_event_id)
            .then(function (response) {
                var copy = response.data || {};
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Business event copied as ' + (copy.biz_event_name || 'a new event'))
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadBizEvents();
            })
            .catch(function (err) {
                dialogService.showErrorDialog(
                    'Copy Failed',
                    dialogService.formatErrorMessage({
                        error: (err.data && err.data.error) || 'Copy Error',
                        message: (err.data && err.data.message) || 'Could not copy the business event.',
                        path: (err.data && err.data.path) || '/v1/api/bizmetry-biz-events/biz-event/' + event.biz_event_id + '/clone',
                        timestamp: (err.data && err.data.timestamp) || new Date().toISOString()
                    })
                );
            })
            .finally(function () { delete $scope.cloningBizEventMap[event.biz_event_id]; });
    };

    $scope.deleteBizEvent = function (event) {
        if (!$scope.confirmDeleteBizEventMap[event.biz_event_id]) {
            // Primer clic: activa el ícono titilante
            $scope.confirmDeleteBizEventMap[event.biz_event_id] = true;

            if ($scope.deleteBizEventTimers[event.biz_event_id]) {
                $timeout.cancel($scope.deleteBizEventTimers[event.biz_event_id]);
            }
            $scope.deleteBizEventTimers[event.biz_event_id] = $timeout(function () {
                $scope.confirmDeleteBizEventMap[event.biz_event_id] = false;
                delete $scope.deleteBizEventTimers[event.biz_event_id];
            }, CONFIRM_TIMEOUT_MS);

        } else {
            // Segundo clic: abre el dialog de confirmación (patrón API Collections)
            $timeout.cancel($scope.deleteBizEventTimers[event.biz_event_id]);
            delete $scope.deleteBizEventTimers[event.biz_event_id];
            $scope.confirmDeleteBizEventMap[event.biz_event_id] = false;

            var isLive = event.enabled && event.live_info && event.live_info.is_live;
            var liveEnvs = isLive ? $scope.getBizEventLiveEnvNames(event.live_info) : '';
            var deleteMsg = 'You are about to permanently delete <strong>' + event.biz_event_name + '</strong>. This action cannot be undone.';
            if (isLive) {
                deleteMsg += '<div style="margin-top:12px;padding:10px 12px;background:rgba(239,68,68,0.07);border-left:3px solid #ef4444;border-radius:4px;font-size:12px;color:#b91c1c;line-height:1.5;">' +
                    '<strong>⚠ This event is currently live' + (liveEnvs ? ' in: ' + liveEnvs : '') + '.</strong><br>' +
                    'If you proceed, all agents associated with this event will immediately stop capturing and forwarding business telemetry frames to the platform.' +
                    '</div>';
            }
            dialogService.showConfirmationDialog(
                'Delete Business Event',
                deleteMsg,
                event.biz_event_name,
                true
            ).then(function (decision) {
                if (decision !== 'confirmed') { return; }

                BusinessEventsService.delete(event.biz_event_id)
                    .then(function () {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Business event deleted successfully')
                                .position('top right')
                                .hideDelay(3000)
                        );
                        var idx = $scope.selectedBizEventIds.indexOf(event.biz_event_id);
                        if (idx > -1) { $scope.selectedBizEventIds.splice(idx, 1); }
                        $scope.loadBizEvents();
                    })
                    .catch(function (err) {
                        dialogService.showErrorDialog(
                            'Delete Failed',
                            dialogService.formatErrorMessage({
                                error: (err.data && err.data.error) || 'Delete Error',
                                message: (err.data && err.data.message) || 'Could not delete the business event.',
                                path: (err.data && err.data.path) || '/v1/api/bizmetry-biz-events/biz-event/' + event.biz_event_id,
                                timestamp: (err.data && err.data.timestamp) || new Date().toISOString()
                            })
                        );
                    });
            });
        }
    };

    // ========================================
    // ELIMINAR VERSION
    // ========================================

    $scope.confirmDeleteVersionMap = {};
    $scope.deleteVersionTimers = {};

    $scope.deleteVersion = function (event, version) {
        var vid = version.biz_event_version_id;

        if (!$scope.confirmDeleteVersionMap[vid]) {
            $scope.confirmDeleteVersionMap[vid] = true;
            if ($scope.deleteVersionTimers[vid]) { $timeout.cancel($scope.deleteVersionTimers[vid]); }
            $scope.deleteVersionTimers[vid] = $timeout(function () {
                $scope.confirmDeleteVersionMap[vid] = false;
                delete $scope.deleteVersionTimers[vid];
            }, 3000);
        } else {
            $timeout.cancel($scope.deleteVersionTimers[vid]);
            delete $scope.deleteVersionTimers[vid];
            $scope.confirmDeleteVersionMap[vid] = false;

            dialogService.showConfirmationDialog(
                'Delete Version',
                'You are about to permanently delete version <strong>v' + version.biz_event_version + '</strong>. This cannot be undone.',
                'v' + version.biz_event_version,
                true
            ).then(function (decision) {
                if (decision !== 'confirmed') { return; }

                BusinessEventsService.deleteVersion(event.biz_event_id, version.biz_event_version)
                    .then(function () {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Version deleted successfully')
                                .position('top right')
                                .hideDelay(3000)
                        );
                        // Remove version from array in-place
                        var eIdx = $scope.filteredBizEvents.findIndex(function (e) {
                            return e.biz_event_id === event.biz_event_id;
                        });
                        if (eIdx !== -1) {
                            $scope.filteredBizEvents[eIdx].versions =
                                $scope.filteredBizEvents[eIdx].versions.filter(function (v) {
                                    return v.biz_event_version_id !== vid;
                                });
                            // If no versions remain, the backend also deleted the header — remove it too
                            if ($scope.filteredBizEvents[eIdx].versions.length === 0) {
                                $scope.filteredBizEvents.splice(eIdx, 1);
                                delete $scope.expandedEvents[event.biz_event_id];
                            }
                        }
                    })
                    .catch(function (err) {
                        dialogService.showErrorDialog('Delete Failed',
                            dialogService.formatErrorMessage({
                                error: (err.data && err.data.error) || 'Delete Error',
                                message: (err.data && err.data.message) || 'Could not delete version.',
                                path: '/v1/api/bizmetry-biz-events/biz-event/' + event.biz_event_id + '/versions/' + vid,
                                timestamp: new Date().toISOString()
                            }));
                    });
            });
        }
    };

    // ========================================
    // ========================================
    // VISIBLE VERSIONS HELPER
    // ========================================

    /**
     * Returns the versions to show for a given biz event row.
     * When liveMode is OFF → all versions.
     * When liveMode is ON  → only versions that have at least one env_info
     *                        with is_live=true (i.e. this specific version is
     *                        currently live in at least one environment).
     */
    var _visibleVersionsCache = {};

    $scope.getVisibleVersions = function (event) {
        var versions = event.versions || [];
        if (!$scope.bizEvent.liveMode) { return versions; }
        var selectedEnvIds = $scope.bizEvent.liveEnvIds;
        var key = event.biz_event_id + ':' + selectedEnvIds.join(',');
        if (_visibleVersionsCache[key]) { return _visibleVersionsCache[key]; }
        var filtered = versions.filter(function (v) {
            var liveEnvInfos = (v.env_infos || []).filter(function (e) { return e.is_live; });
            if (!liveEnvInfos.length) { return false; }
            // Sin filtro → cualquier versión live pasa
            if (!selectedEnvIds.length) { return true; }
            // AND: la versión debe estar live en TODOS los envs seleccionados
            var liveIds = liveEnvInfos.map(function (e) { return e.id; });
            return selectedEnvIds.every(function (id) { return liveIds.indexOf(id) > -1; });
        });
        _visibleVersionsCache[key] = filtered;
        return filtered;
    };

    // Cuando cambia el filtro de environments, resetear cache y recargar
    $scope.onLiveEnvFilterChange = function () {
        _visibleVersionsCache = {};
        $scope.bizEvent.page = 0;
        $scope.loadBizEvents();
    };

    // ========================================
    // CUSTOM ENV DROPDOWN — panel inyectado en document.body
    // para escapar cualquier transform/overflow de ancestros
    // ========================================

    $scope.envDropdownOpen = false;
    var _envPanel = null;   // referencia al DOM del panel inyectado

    function _buildEnvPanel() {
        var panel = document.createElement('div');
        panel.className = 'be-env-panel';
        panel.style.display = 'none';

        var inner = document.createElement('div');
        inner.className = 'be-env-panel-inner';
        panel.appendChild(inner);

        function _renderOptions() {
            inner.innerHTML = '';
            ($scope.liveEnvOptions || []).forEach(function (env) {
                var row = document.createElement('div');
                row.className = 'be-env-option' + ($scope.isEnvSelected(env.id) ? ' be-env-option--checked' : '');
                row.innerHTML =
                    '<span class="be-env-checkbox">' +
                    ($scope.isEnvSelected(env.id) ? '<span class="be-env-check-mark">✓</span>' : '') +
                    '</span>' +
                    '<span class="be-env-option-name">' + env.name + '</span>';
                row.addEventListener('click', function (e) {
                    e.stopPropagation();
                    $scope.$apply(function () { $scope.toggleEnvSelection(env.id); });
                    _renderOptions();   // re-render checkmarks
                });
                inner.appendChild(row);
            });
        }

        panel._renderOptions = _renderOptions;
        document.body.appendChild(panel);
        return panel;
    }

    function _positionEnvPanel(triggerEl) {
        // Usa el rect del trigger relativo al documento (scroll-aware)
        var rect = triggerEl.getBoundingClientRect();
        var scrollTop  = window.pageYOffset || document.documentElement.scrollTop;
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        _envPanel.style.top      = Math.round(rect.bottom + scrollTop  + 4) + 'px';
        _envPanel.style.left     = Math.round(rect.left   + scrollLeft)     + 'px';
        _envPanel.style.minWidth = Math.round(rect.width)                   + 'px';
    }

    $scope.toggleEnvDropdown = function ($event) {
        $event.stopPropagation();

        if (!_envPanel) { _envPanel = _buildEnvPanel(); }

        if ($scope.envDropdownOpen) {
            _envPanel.style.display = 'none';
            $scope.envDropdownOpen = false;
        } else {
            // Buscar el botón trigger subiendo por el DOM
            var el = $event.target;
            while (el && !el.classList.contains('be-env-trigger')) { el = el.parentElement; }
            if (!el) { el = $event.currentTarget; }

            _envPanel._renderOptions();
            _positionEnvPanel(el);
            _envPanel.style.display = 'block';
            $scope.envDropdownOpen = true;
        }
    };

    $scope.isEnvSelected = function (id) {
        return $scope.bizEvent.liveEnvIds.indexOf(id) > -1;
    };

    $scope.toggleEnvSelection = function (id) {
        var idx = $scope.bizEvent.liveEnvIds.indexOf(id);
        if (idx > -1) {
            $scope.bizEvent.liveEnvIds.splice(idx, 1);
        } else {
            $scope.bizEvent.liveEnvIds.push(id);
        }
        $scope.onLiveEnvFilterChange();
    };

    $scope.getEnvFilterLabel = function () {
        var ids = $scope.bizEvent.liveEnvIds;
        if (!ids || !ids.length) { return 'All'; }
        var names = $scope.liveEnvOptions
            .filter(function (e) { return ids.indexOf(e.id) > -1; })
            .map(function (e) { return e.name; });
        if (names.length === 1) { return names[0]; }
        return names[0] + ' +' + (names.length - 1);
    };

    // Cerrar el dropdown al hacer click fuera
    var _envDropdownClickHandler = function (e) {
        if (!$scope.envDropdownOpen) { return; }
        var trigger = document.querySelector('.be-env-trigger');
        var panelEl = _envPanel;
        var clickInTrigger = trigger && trigger.contains(e.target);
        var clickInPanel   = panelEl  && panelEl.contains(e.target);
        if (!clickInTrigger && !clickInPanel) {
            $scope.$apply(function () {
                $scope.envDropdownOpen = false;
                if (_envPanel) { _envPanel.style.display = 'none'; }
            });
        }
    };
    document.addEventListener('click', _envDropdownClickHandler);

    // EVENT SOURCE GROUPS HELPER
    // ========================================

    /**
     * Deduplicates biz_event_sources by api_collection_id and returns one entry
     * per unique collection: { collectionId, collectionName, collectionVersion }.
     * Used by the Event Source column to show collection name + version pill only.
     *
     * Results are memoized by version id to return a stable array reference on
     * every digest cycle — returning a new array each time would cause AngularJS
     * to enter an infinite digest loop ($rootScope:infdig).
     */
    var _sourceGroupsCache = {};

    $scope.getSourceGroups = function (sources, versionId) {
        if (!sources || !sources.length) { return []; }
        if (_sourceGroupsCache[versionId]) { return _sourceGroupsCache[versionId]; }
        var seen = {};
        var groups = [];
        sources.forEach(function (s) {
            var key = s.api_collection_id || s.api_collection_name || '';
            if (!seen[key]) {
                seen[key] = true;
                groups.push({
                    collectionId: key,
                    collectionName: s.api_collection_name || '—',
                    collectionVersion: s.api_collection_version || null
                });
            }
        });
        _sourceGroupsCache[versionId] = groups;
        return groups;
    };

    // Invalidate the source-groups cache whenever the event list is refreshed
    // so stale groups don't survive a reload or status transition.
    var _clearSourceGroupsCache = function () {
        _sourceGroupsCache = {};
        _visibleVersionsCache = {};
    };

    // ========================================
    // TRIGGER ICON HELPER
    // ========================================

    /**
     * Returns "Development · Production" from live_info.envs for the live dot tooltip.
     * Mirrors the getLiveEnvNames() helper in TemplateTabController.
     */
    /**
     * Returns env names from a version_live_info object (provided by the backend).
     * The backend is the source of truth — no frontend computation needed.
     */
    $scope.getVersionLiveEnvNamesFromInfo = function (versionLiveInfo) {
        if (!versionLiveInfo || !versionLiveInfo.envs) return '';
        return versionLiveInfo.envs
            .filter(function (e) { return e.is_live; })
            .map(function (e) { return e.name; })
            .join(', ');
    };

    $scope.getBizEventLiveEnvNames = function (liveInfo) {
        if (!liveInfo || !Array.isArray(liveInfo.envs) || !liveInfo.envs.length) return '';
        return liveInfo.envs.map(function (e) { return e.name; }).join(' · ');
    };

    $scope.getBizEventTriggerIcon = function (triggerId) {
        return BusinessEventsService.describeGrammar(triggerId).icon;
    };

    $scope.getBizEventTriggerLabel = function (triggerId) {
        return BusinessEventsService.describeGrammar(triggerId).label;
    };

    // CSS class suffix for trigger badge, e.g. "REST-API" → "restapi", "FIXED_WIDTH" → "fixedwidth"
    $scope.getBizEventTriggerClass = function (triggerId) {
        return BusinessEventsService.describeGrammar(triggerId).css;
    };

    // ========================================
    // CLEANUP
    // ========================================

    $scope.$on('$destroy', function () {
        document.removeEventListener('click', _envDropdownClickHandler);
        if (_envPanel && _envPanel.parentNode) { _envPanel.parentNode.removeChild(_envPanel); }
        if (searchTimeout) { $timeout.cancel(searchTimeout); }
        Object.keys($scope.deleteBizEventTimers || {}).forEach(function (k) {
            $timeout.cancel($scope.deleteBizEventTimers[k]);
        });
        Object.keys($scope.deleteVersionTimers || {}).forEach(function (k) {
            $timeout.cancel($scope.deleteVersionTimers[k]);
        });
        if (autoRefreshTimer) { $interval.cancel(autoRefreshTimer); }
    });

    // ========================================
    // AUTO-REFRESH — is_live/live_info come from the Agent's periodic sync,
    // so this list can go stale just sitting on screen. Interval is
    // configuration-driven (frontend.biz_events_refresh_interval,
    // central-config ConfigMap on bizmetry-shared-services), not hardcoded.
    //
    // md-tabs' `md-enable-disconnect` only disconnects the inactive tab's
    // scope from the digest/event tree — it never destroys it — so the
    // `ng-if="selectedTabIndex === 6"` guard in profile-details-dialog.html
    // never gets to re-evaluate once we leave this tab, and $destroy above
    // never fires. So the tick itself has to re-check that this tab is
    // still the active one (a plain property read still works through the
    // disconnected scope's prototype chain) instead of relying on cleanup.
    // ========================================

    // Composer dialogs (create/edit wizards, mappings editor) pause the refresh
    // while open; it resumes on its own once the last one closes.
    var _openDialogs = 0;
    function _showPausingRefresh(options) {
        _openDialogs++;
        var promise = $mdDialog.show(options);
        var resume = function () { _openDialogs = Math.max(0, _openDialogs - 1); };
        promise.then(resume, resume);   // hide and cancel both resume
        return promise;
    }

    // Every refreshMs — or every PENDING_REFRESH_MS while IntelliSense works on a listed version,
    // so its editors unlock as soon as it finishes.
    var refreshMs = ConfigurationService.getFromCache('frontend.biz_events_refresh_interval') || 10000;
    var PENDING_REFRESH_MS = 4000;
    var lastRefresh = Date.now();
    function _anyIntelliSensePending() {
        return ($scope.filteredBizEvents || []).some(function (e) {
            return (e.versions || []).some(function (v) { return !!BusinessEventsService.intelliSensePendingSince(v); });
        });
    }
    var autoRefreshTimer = $interval(function () {
        if ($scope.selectedTabIndex !== 6) { return; }
        if (_openDialogs > 0) { return; }
        var due = _anyIntelliSensePending() ? Math.min(PENDING_REFRESH_MS, refreshMs) : refreshMs;
        if (Date.now() - lastRefresh < due) { return; }
        if ($scope.profile && $scope.profile.id && $scope._bizEventsLoadedOnce) {
            lastRefresh = Date.now();
            $scope.loadBizEvents(true);
        }
    }, 2000);

    // ========================================
    // AUTO-LOAD al entrar al tab
    // ========================================

    function safeInitialLoad() {
        if (!$scope.profile || !$scope.profile.id) { return; }
        if (!$scope._bizEventsLoadedOnce) {
            $scope._bizEventsLoadedOnce = true;
            $scope.loadBizEvents();
        }
    }

    $timeout(function () { safeInitialLoad(); }, 0);

    $scope.$on('biz-events:tab-selected', function () {
        if (!$scope._bizEventsLoadedOnce) {
            safeInitialLoad();
        } else {
            $scope.loadBizEvents();
        }
    });

    $scope.$watch('profile.id', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            $scope._bizEventsLoadedOnce = false;
            safeInitialLoad();
        }
    });

    $scope.getBizEventSourceIcon = function (sourceType) {
        const icons = {
            'REST-API': 'http',
            'MQTT-QUEUE': 'sensors',
            'KAFKA-TOPIC': 'stream',
            'WEBHOOK': 'webhook',
            'SFTP': 'dns',
            'FILE_SYSTEM': 'folder_open'
        };
        return icons[sourceType] || 'input';
    };

});
// ============================================================
// DIRECTIVE: beInlineFocus — auto-focuses input when condition
// is truthy (used by inline-edit cells in biz-events table)
// ============================================================
angular.module('bizmetryApp').directive('beInlineFocus', function ($timeout) {
    return {
        restrict: 'A',
        scope: { beInlineFocus: '=' },
        link: function (scope, element) {
            scope.$watch('beInlineFocus', function (val) {
                if (val) {
                    $timeout(function () {
                        element[0].focus();
                        element[0].select();
                    }, 30);
                }
            });
        }
    };
});